import React, { Component } from 'react';

import './EstrategiaLongoPrazo.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import Parallax from 'parallax-js';

import {
	TimelineMax,
	TweenMax
} from 'gsap';

import renderHTML from 'react-render-html';
import Swipeable from 'react-swipeable';
import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images
} from '../../settings';

import {
	Compromisso
} from '../../components/';

class EstrategiaLongoPrazo extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
            width: window.innerWidth,
            cardsDiretores: 0,
            lineDiretoresLeft: 0,
        	compromissosStep: null,
        	compromisso0: '',
        	compromisso1: '',
        	compromisso2: '',
        	compromisso3: '',
        	activeButtons: 'compromissos__buttons--0',
        	intervalId: 0,
        	currentSlide: 0,
        	maxSlides: 3,
        	sliderTime: 15000
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);

	    this.changeCompromissos = this.changeCompromissos.bind(this);
	    this.changeCompromissosButton = this.changeCompromissosButton.bind(this);
	    this.changeCompromissosMobileNext = this.changeCompromissosMobileNext.bind(this);
	    this.changeCompromissosMobilePrev = this.changeCompromissosMobilePrev.bind(this);
	    this.timer = this.timer.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

    globalTransition() {
    	Actions.globalTransition();
    }

    changeCompromissos(num) {
    	if (this.state.compromissosStep != num) {
    		this.setState({
    			compromissosStep : num,
    			activeButtons: 'compromissos__buttons--' + num
    		});

    		this.setState({
    			compromisso0 : '',
    			compromisso1 : '',
    			compromisso2 : '',
    			compromisso3 : ''
    		});

    		switch (num) {
    			case 0:
    				this.setState({ compromisso0 : 'active' });
    				break;
    			case 1:
    				this.setState({ compromisso1 : 'active' });
    				break;
    			case 2:
    				this.setState({ compromisso2 : 'active' });
    				break;
    			case 3:
    				this.setState({ compromisso3 : 'active' });
    				break;
    		}
    	}
    }

    changeCompromissosButton(num) {
    	this.changeCompromissos(num);
    	this.clearTimer();
    	this.initTimer();
    }

    changeCompromissosMobileNext() {
    	let nextCompromisso = this.state.compromissosStep + 1;
    	this.changeCompromissos( (nextCompromisso <= this.state.maxSlides) ? nextCompromisso : 0 );
    	this.reloadTimer();
	}

    changeCompromissosMobilePrev() {
    	let prevCompromisso = this.state.compromissosStep - 1;
    	this.changeCompromissos( (prevCompromisso >= 0) ? prevCompromisso : this.state.maxSlides );
    	this.reloadTimer();
	}

	timer() {
		let newSlide;

		if (this.state.compromissosStep < this.state.maxSlides) {
			newSlide = this.state.compromissosStep + 1;
		} else {
			newSlide = 0;
		}

		console.log('newSlide', newSlide); 

		this.changeCompromissos(newSlide);
		// this.setState({ compromissosStep : newSlide });
	}

	reloadTimer() {
    	this.clearTimer();
    	this.initTimer();
	}

	clearTimer() {
		clearInterval(this.state.intervalId);
	}

	initTimer() {
		var intervalId = setInterval(this.timer, this.state.sliderTime);
		this.setState({ intervalId: intervalId });
	}

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('6.3 ANBIMA +5');
    }

    componentWillUnmount() {
		this.clearTimer();
	}

    componentDidMount() {
    	this.initTimer();
    	this.changeCompromissos(0);
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'longo-prazo'
		];

		let slideClassItem = [
			'compromissos__body',
			'compromissos__body--' + this.state.compromissosStep
		];

		let compromissoButtonsClassItem = [
			'container', 'compromissos__buttons', this.state.activeButtons
		];

		let compromisso0ClassItem = [
			'compromissos__btn',
			'compromissos__btn--representar',
			'compromissos__btn--' + this.state.compromisso0
		];

		let compromisso1ClassItem = [
			'compromissos__btn',
			'compromissos__btn--autorregular',
			'compromissos__btn--' + this.state.compromisso1
		];

		let compromisso2ClassItem = [
			'compromissos__btn',
			'compromissos__btn--informar',
			'compromissos__btn--' + this.state.compromisso2
		];

		let compromisso3ClassItem = [
			'compromissos__btn',
			'compromissos__btn--educar',
			'compromissos__btn--' + this.state.compromisso3
		];

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>6.3 ANBIMA +5 - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>6.3</span> ANBIMA +5</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Estratégia</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<h3 className="first_title">
					        				<span className="gri_label"><text>GRI 102-15</text></span>
					        			</h3>
				        				<p className="first_p">
					        				A visão de longo prazo da Associação está refletida no ANBIMA +5, projeto que traçou a estratégia para os próximos cinco anos.
					        				<br />
					        				Ela é construída a partir de análises de cenários para os mercados que representamos e considera as quatro principais atividades da entidade:
										</p>

				        				<h2 className="blue_title">representar, autorregular, informar e educar.</h2>
				        				<p>
					        				Para cada uma delas foram estabelecidas diretrizes de trabalho, definidas a partir de consultas a associados, representantes de outras instituições do mercado e membros do governo.
										</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content views__content--section compromissos">
			        		<Swipeable
		        				className="row compromissos__header"
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<img className="compromissos_arrow" src={ this.images.quem_somos_perfil_arrow } />

				        		<div className={ compromissoButtonsClassItem.join(' ') }>
					        		<div className={ compromisso0ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 0) }>
					        			<span className="btn__text">Representar</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso1ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 1) }>
					        			<span className="btn__text">Autorregular</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso2ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 2) }>
					        			<span className="btn__text">Informar</span>
					        			<div className="btn__loader"></div>
					        		</div>
					        		<div className={ compromisso3ClassItem.join(' ') } onClick={ this.changeCompromissosButton.bind(null, 3) }>
					        			<span className="btn__text">Educar</span>
					        			<div className="btn__loader"></div>
					        		</div>
				        		</div>
			        		</Swipeable>
			        		<Swipeable
			        			className={ slideClassItem.join(' ') }
			        			onSwipedLeft={ this.changeCompromissosMobileNext }
			        			onSwipedRight={ this.changeCompromissosMobilePrev }>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_rep }
			        				title="Representar"
			        				subtitle="Implementação em 2019"
			        				slug="representar">
			        				<div className="compromisso__content">
			        					<p>Reflexão sobre a melhor forma de organização para continuar defendendo os interesses dos associados, garantindo representatividade e efetividade nas discussões.</p>
				        				<h3>Direcionadores da atuação:</h3>
				        				<ul>
				        					<li>Assegurar o equilíbrio participativo de todos os segmentos do mercado representados na ANBIMA, especialmente nos comitês; </li>
											<li>Organizar os fóruns por um critério único: a atividade exercida no mercado (gestão de recursos, administração, etc.) em linha com a mudança na autorregulação, que tira o foco das regras do produto e mira a atividade dos profissionais;</li>
											<li>Propor um novo modelo de governança com a divisão de responsabilidades e atribuições entre os diferentes órgãos que fazem parte do modelo de governança da ANBIMA.</li>
				        				</ul>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_aut }
			        				title="Autorregular"
			        				subtitle="Implementação em 2019"
			        				slug="autorregular">
			        				<div className="compromisso__content">
			        					<p>Discussão voltada para as consequências da mudança de foco das regras da autorregulação do produto, como foi feito historicamente, para as atividades dos profissionais do mercado.</p>
				        				<h3>Direcionadores da atuação:</h3>
				        				<ul>
				        					<li>Manter o modelo de autorregulação privado e independente, ou seja, exercido sem mandato do governo;</li>
											<li>Manter o estreito relacionamento com reguladores por meio de convênios – por exemplo, a nova parceria na supervisão de fundos – com objetivo de potencializar sinergias e diminuir redundâncias entre a regulação e a autorregulação;</li>
											<li>Evoluir o modelo de supervisão e monitoramento de conduta dos profissionais do mercado.</li>
				        				</ul>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_inf }
			        				title="Informar"
			        				subtitle="Estratégia 100% implementada"
			        				slug="informar">
			        				<div className="compromisso__content">
			        					<p>Discussão sobre melhorias nas informações fornecidas ao mercado com objetivo de fomentar os negócios.</p>
				        				<h3>Direcionadores da atuação:</h3>
				        				<ul>
				        					<li>Aprimorar a governança e os processos da precificação;</li>
											<li>Otimizar e aperfeiçoar as bases de dados e os relatórios divulgados para o mercado;</li>
											<li>Construir uma plataforma de dados de mercado de capitais – o ANBIMA Data, sistema lançado em 2018 –, que funcionará  como uma grande base de dados para agregar informações que aumentem a transparência.</li>
				        				</ul>
			        				</div>
			        			</Compromisso>

			        			<Compromisso
			        				icon={ this.images.quem_somos_perfil_icon_edu }
			        				title="Educar"
			        				subtitle="Estratégia 100% implementada"
			        				slug="educar">
			        				<div className="compromisso__content">
			        					<p>Debate sobre necessidade de uma estratégia específica para cada público: profissionais do mercado (papel certificador), investidores (papel instrutivo) e público em geral (papel social).</p>
				        				<h3>Direcionadores da atuação:</h3>
				        				<ul>
				        					<li>Qualificar o profissional do mercado com as certificações e cursos de educação continuada;</li>
											<li>Desenvolver programas de educação e informação ao investidor norteados por pesquisas que ajudem a entender esse público, pela criação de conteúdo e também via programas de educação financeira para jovens universitários;</li>
											<li>Fomentar ações sociais de educação financeira, por meio de parcerias com o governo e outras entidades, por exemplo, a participação na Enef (Estratégia Nacional de Educação Financeira).</li>
				        				</ul>
			        				</div>
			        			</Compromisso>
			        		</Swipeable>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { EstrategiaLongoPrazo };
